"use client";

import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";

const GoToTop = () => {
  const [isInvert, setIsInvert] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const footer = document.querySelector("footer");
    if (!footer || !buttonRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInvert(true);
          } else {
            setIsInvert(false);
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
      },
    );

    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={buttonRef}
      onClick={handleClick}
      className={`fixed bottom-6 right-6 z-[9999] flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-[#0000001C] bg-[#0000000A] transition ${isVisible ? "opacity-100" : "pointer-events-none opacity-0"}`}
    >
      <Image
        src={"/images/icons/arrow-up-03-round.svg"}
        className={`${isInvert ? "" : "invert"}`}
        width={32}
        height={32}
        alt="go-to-top"
      />
    </div>
  );
};

export default GoToTop;
